import { isPlainRecord } from '@terra/shared-dto-chat-types';
import type { PayloadFormatter } from './tools/shared/types';

export function formatToolInputPayload({
  formatPayload,
  input,
}: {
  formatPayload?: PayloadFormatter;
  input: unknown;
}): string | null {
  if (!formatPayload || !isPlainRecord(input)) {
    return null;
  }

  return formatPayload(input);
}

export function readTaskDescriptionFromToolInput(
  input: unknown,
): string | undefined {
  if (!isPlainRecord(input)) {
    return undefined;
  }

  return typeof input.taskDescription === 'string'
    ? input.taskDescription
    : undefined;
}
